import { render } from "./EmployeeDetailsPageProfile.vue?vue&type=template&id=c034fbd6"
import script from "./EmployeeDetailsPageProfile.vue?vue&type=script&lang=ts"
export * from "./EmployeeDetailsPageProfile.vue?vue&type=script&lang=ts"
script.render = render

export default script